import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, HostBinding, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';

import { LAYOUT } from '../../layout.constants';
import { LayoutService } from '../../services/layout.service';
import { checkRouterChildsData } from '../../utils/check-router-childs-data';

/** Only rendered below the desktop breakpoint, where the sidenav becomes an overlay. */
@Component({
  selector: 'rms-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  imports: [MatButtonModule, MatIconModule, AsyncPipe, TranslatePipe],
})
export class ToolbarComponent implements OnInit {
  @HostBinding('class.shadow-b')
  public showShadow = false;

  public readonly logoUrl = LAYOUT.toolbarLogoUrl;
  public readonly isDesktop$: Observable<boolean>;

  private readonly layoutService = inject(LayoutService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.isDesktop$ = this.layoutService.isDesktop$;
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.showShadow = checkRouterChildsData(
          this.router.routerState.root.snapshot,
          (data) => data.toolbarShadowEnabled ?? false
        );
      });
  }

  public openSidenav(): void {
    this.layoutService.openSidenav();
  }
}
